import { combineReducers } from "redux";
import absences from "./slices/absencesSlice";
import account from "./slices/accountSlice";
import auth from "./slices/authSlice";
import calendars from "./slices/calendarSlice";
import categories from "./slices/categoriesSlice";
import courses from "./slices/coursesSlice";
import dashboard from "./slices/dashboardSlice";
import emails from "./slices/emailsSlice";
import events from "./slices/eventsSlice";
import expenses from "./slices/expensesSlice";
import instructors from "./slices/instructorsSlice";
import internships from "./slices/internshipsSlice";
import liveStreams from "./slices/liveStreamsSlice";
import modals from "./slices/modalsSlice";
import payments from "./slices/paymentsSlice";
import productCategory from "./slices/productsCategorySlice";
import products from "./slices/productsSlice";
import rooms from "./slices/roomsSlice";
import salaries from "./slices/salariesSlice";
import schools from "./slices/schoolsSlice";
import students from "./slices/studentsSlice";
import theme from "./slices/themeSlice";
import trainings from "./slices/trainingsSlice";
import tutorials from "./slices/tutorialsSlice";
import groups from "./slices/groupsSlice";
import supportCourses from "./slices/supportCoursesSlice";
import subjects from "./slices/subjectsSlice";
import registrations from "./slices/registrationsSlice";
import adminschool from "store/slices/adminschoolSlice";
import subscriptions from "./slices/subscriptionsSlice";
import subscriptionEnrollments from "./slices/subscriptionEnrollmentsSlice";
import promotions from "store/slices/promotionsSlice";
import sessionTracking from "./slices/sessionTrackingSlice";
import bulkEmails from "./slices/bulkEmailsSlice";
import platformTutorials from "./slices/platformTutorialsSlice";
import quizzes from "./slices/quizzesSlice";
import quizParticipants from "./slices/quizParticipantsSlice";
import assignments from "./slices/assignmentsSlice";
import notifications from "./slices/notificationsSlice";
import feedbacks from "./slices/feedbacksSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    account,
    instructors,
    liveStreams,
    modals,
    schools,
    rooms,
    categories,
    trainings,
    courses,
    expenses,
    internships,
    students,
    emails,
    calendars,
    salaries,
    dashboard,
    absences,
    payments,
    products,
    productCategory,
    events,
    tutorials,
    groups,
    supportCourses,
    subjects,
    registrations,
    adminschool,
    subscriptions,
    subscriptionEnrollments,
    promotions,
    sessionTracking,
    bulkEmails,
    platformTutorials,
    quizzes,
    quizParticipants,
    assignments,
    notifications,
    feedbacks,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
